import { Component, inject, output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

import { AuthFacade } from "state/auth.facade";

import { NavLinksService } from "../../services/nav-links.service";

@Component({
  selector: "app-mobile-nav",
  templateUrl: "./mobile-nav.component.html",
  styleUrls: ["./mobile-nav.component.scss"],
  standalone: true,
  host: { class: "inseer-ds" },
  imports: [RouterModule, TranslateModule, MatButtonModule, MatIconModule],
})
export class MobileNavComponent {
  private readonly authFacade = inject(AuthFacade);
  private readonly navLinks = inject(NavLinksService);

  readonly navigated = output<void>();

  protected readonly links = this.navLinks.links;
  protected readonly showCreate = this.navLinks.showCreate;

  protected logout(): void {
    this.navigated.emit();
    this.authFacade.logout();
  }
}
